/* eslint-disable vue/multi-word-component-names */
import Vue from "vue";

// PrimeVue
import PrimeVue from "primevue/config";
Vue.use(PrimeVue);

// PrimeVue Styles
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";

// PrimeVue Components
import Button from "primevue/button";
Vue.component("Button", Button);

import Checkbox from "primevue/checkbox";
Vue.component("Checkbox", Checkbox);

import DataTable from "primevue/datatable";
Vue.component("DataTable", DataTable);

import Column from "primevue/column";
Vue.component("Column", Column);

import ColumnGroup from "primevue/columngroup";
Vue.component("ColumnGroup", ColumnGroup);

import Row from "primevue/row";
Vue.component("Row", Row);

import InputText from "primevue/inputtext";
Vue.component("InputText", InputText);

import Dropdown from "primevue/dropdown";
Vue.component("Dropdown", Dropdown);

import ProgressSpinner from "primevue/progressspinner";
Vue.component("ProgressSpinner", ProgressSpinner);

import Toast from "primevue/toast";
Vue.component("Toast", Toast);

import InlineMessage from "primevue/inlinemessage";
Vue.component("InlineMessage", InlineMessage);

import Card from "primevue/card";
Vue.component("Card", Card);

import InputMask from "primevue/inputmask";
Vue.component("InputMask", InputMask);

import ToastService from "primevue/toastservice";
Vue.use(ToastService);
